<template>
  <div v-if="currentSession.activeStepKey != 'Vehicle.Plate' && currentSession.activeStepKey != 'VehicleAlt.Confirm' ">
    <a v-on:click="back()" class="back" >Back</a>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  // props: {
  //   model: {
  //     type: Array,
  //     required: true
  //   }
  // },
  components: {

  },
  methods: {
    back: function() {
      this.currentSession.stepPath.pop();
      this.$router.push({name: this.currentSession.stepPath.slice(-1)[0] });
      //this.$router.go(-1);
    }
  },
  computed: {
      ...mapGetters(['currentSession'])
  },
  data () {
    return {
      
    }
  }
}

</script>

<style scoped lang="scss">
  .back {
    font-size:0.9rem;

    &:before {
      content:"\2190";
      display:inline-block;
      padding-right:0.5rem;
    }
  }
</style>